import type { MediaType } from '@shared/models/media.model';

export const changeCoverPhoto = (media: MediaType[]) => {
  const copyMedia = [...media];

  const isHaveCover = copyMedia.some((photo) => photo.is_cover);

  if (!isHaveCover && copyMedia.length > 0) {
    const lastMediaIndex = media.length - 1;
    const lastMedia = copyMedia[lastMediaIndex];
    copyMedia[lastMediaIndex] = { ...lastMedia, is_cover: true };
  }

  return { photos: copyMedia };
};
